import React from 'react';

interface HistoryIconProps {
    width?: string | number;
    height?: string | number;
    colour?: string;
}

// Owner/field history trigger icon (per RECUR-25948 UAT — `history-...svg`).
// A "history" glyph (clock with a counter-clockwise arrow), distinct from the
// plain ClockIcon. Default colour #4D4D4D matches the design.
const HistoryIcon = ({ width = '20', height = '20', colour = '#4D4D4D' }: HistoryIconProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.98374 17.0807C8.17929 17.0807 6.60665 16.4867 5.26582 15.2986C3.92499 14.1106 3.15311 12.6213 2.9502 10.8307H4.22582C4.43624 12.2699 5.08395 13.463 6.16895 14.4101C7.25381 15.3572 8.5254 15.8307 9.98374 15.8307C11.6087 15.8307 12.9872 15.2648 14.1192 14.1328C15.2511 13.0009 15.8171 11.6224 15.8171 9.9974C15.8171 8.3724 15.2511 6.99392 14.1192 5.86198C12.9872 4.73003 11.6087 4.16406 9.98374 4.16406C9.07346 4.16406 8.2204 4.36628 7.42457 4.77073C6.6286 5.17503 5.94318 5.73135 5.36832 6.43969H7.5479V7.68969H3.31707V3.45885H4.56707V5.43323C5.24332 4.63517 6.05318 4.0158 6.99665 3.5751C7.93999 3.13441 8.93568 2.91406 9.98374 2.91406C10.9667 2.91406 11.8876 3.09997 12.7467 3.47177C13.6055 3.84358 14.3544 4.34892 14.9933 4.98781C15.6322 5.6267 16.1376 6.37566 16.5094 7.23469C16.8812 8.09358 17.0671 9.01448 17.0671 9.9974C17.0671 10.9803 16.8812 11.9012 16.5094 12.7601C16.1376 13.6191 15.6322 14.3681 14.9933 15.007C14.3544 15.6459 13.6055 16.1512 12.7467 16.523C11.8876 16.8948 10.9667 17.0807 9.98374 17.0807ZM12.4854 13.3532L9.3829 10.2505V5.83073H10.6327V9.74427L13.3635 12.4749L12.4854 13.3532Z"
                fill={colour}
            />
        </svg>
    );
};

export default HistoryIcon;
